import { render } from "./Bio.vue?vue&type=template&id=3c86d6ee"
import script from "./Bio.vue?vue&type=script&lang=js"
export * from "./Bio.vue?vue&type=script&lang=js"
script.render = render

export default script